import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Typography } from "@mui/material";
import { isMobile } from "react-device-detect";
import DownloadPDFIcon from "./icons/DownloadPDFIcon";
import CloseIcon from "@mui/icons-material/Close";
import { AccreditationCardStyle, AccreditationDetailPageStyle } from "../pages/AccreditationDetailPage";
import { CertArticle } from "../adapters/api";
import { useTranslation } from "react-i18next";

export type AccreditationDetailModalProps = {
    open: boolean;
    handleClose: () => void;
    selectedItem: CertArticle | undefined;
};

// Modale di dettaglio di una certificazione
export default function AccreditationDetailModal({open, handleClose, selectedItem}: AccreditationDetailModalProps) {
    const { t } = useTranslation();
    return <Dialog
                PaperProps={{
                    sx: isMobile
                        ? AccreditationDetailPageStyle.dialogContainerMobile
                        : AccreditationDetailPageStyle.dialogContainer,
                }}
                fullWidth={true}
                scroll="paper"
                maxWidth={"lg"}
                open={open}
                onClose={handleClose}
            >
                <DialogTitle
                    sx={
                        isMobile
                            ? AccreditationCardStyle.dialogTitleMobile
                            : AccreditationDetailPageStyle.dialogTitle
                    }
                >
                    {selectedItem?.title}
                    <Typography>{selectedItem?.createdDate}</Typography>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.secondary.main,
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent sx={AccreditationDetailPageStyle.dialogContent}>
                    <Box display={"flex"} justifyContent={"center"} width={"100%"}>
                    {
                        selectedItem?.image ? <img  style={{maxHeight: "350px", maxWidth: "100%", marginBottom: "20px"}} src={"/backend/static/" + selectedItem.image}/> : null
                    }
                    </Box>
                    <DialogContentText
                        sx={
                            isMobile
                                ? AccreditationDetailPageStyle.dialogContentTextMobile
                                : AccreditationDetailPageStyle.dialogContentText
                        }
                        style={{ whiteSpace: "pre-line" }}
                    >
                        {selectedItem?.content}
                    </DialogContentText>
                    
                    <Box
                        noValidate
                        component="form"
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            m: "auto",
                            width: "fit-content",
                        }}
                    ></Box>
                </DialogContent>
                <DialogActions>
                    {
                        selectedItem?.attachment ?
                        <Button
                            sx={
                                isMobile
                                    ? AccreditationDetailPageStyle.dialogButtonMobile
                                    : AccreditationDetailPageStyle.dialogButton
                            }
                            size="small"
                            endIcon={<DownloadPDFIcon />}
                            target="_blank"
                            href={"/backend/static/" + selectedItem?.attachment}
                        >
                            {t("accred.details.download")}
                        </Button>
                        :
                        selectedItem?.url ?
                        <Button
                            sx={
                                isMobile
                                    ? AccreditationDetailPageStyle.dialogButtonMobile
                                    : AccreditationDetailPageStyle.dialogButton
                            }
                            size="small"
                            endIcon={<DownloadPDFIcon />}
                            target="_blank"
                            href={selectedItem?.url}
                        >
                            {t("accred.details.view")}
                        </Button>
                        : null
                    }
                </DialogActions>
            </Dialog>
}